import React, { Fragment, useState, useEffect, useRef } from 'react'
import {
    Cog6ToothIcon,
} from '@heroicons/react/24/outline'
import { useNavigate, useParams } from "react-router-dom";
import { ClockHistory, Code, Search, TextLeft, ChevronLeft, ChevronRight, Trash2Fill, Trash, BarChart } from 'react-bootstrap-icons';
import { BsStars, BsThreeDotsVertical } from "react-icons/bs";
import { useSelector } from 'react-redux';
import { cleanChatHistory, deleteChat, setListingData } from '../../redux/actions/queryZoiAction';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { MdDeleteOutline } from "react-icons/md";
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon,HomeIcon  } from "@heroicons/react/24/outline";
import { GoSidebarExpand } from "react-icons/go";
import { GoSidebarCollapse } from "react-icons/go";
import { DiNetbeans } from "react-icons/di";





const Sidebar = ({ subPageName, authToken, collapsed, setCollapsed }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [more, setMore] = useState(true);
  const [show, setShow] = useState(false);
  const [ptoken, setPToken] = useState("");
  let { id } = useParams();
  const chat_history = useSelector((state) => state.queryzoi.chat_history?.details);
  const isLoadings = useSelector((state) => state.queryzoi.ama_loading);
  const userType = useSelector((state) => state.assetLibrary.userData?.user_type);
  const [menuOpen, setMenuOpen] = useState(null);
  const menuRefs = useRef([]);

  useEffect(() => {
    if (menuOpen !== null) {
      const handleClickOutside = (event) => {
        if (
          menuRefs.current[menuOpen] &&
          !menuRefs.current[menuOpen].contains(event.target)
        ) {
          setMenuOpen(null);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [menuOpen]);

  function classNames(...classes) {
      return classes.filter(Boolean).join(' ')
  }
  
  const redirectHome = () => {
        const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
        const randomIdQuery = Math.floor(Math.random() * 900000) + 100000;
        Cookies.set("qzoi", `q-zoi-${randomIdQuery}`, { expires: expiryDate });
        dispatch(setListingData());
        navigate(`/internal_ama`);
  };

  const handleClear = () => {
    dispatch(cleanChatHistory(authToken));
  }

  const handleDelete =(p_token) =>{
    setShow(true);
    setPToken(p_token);
  }
 const handleClose = () =>{
  setShow(false);
  setPToken("")
 }

 const deleteEvent = () =>{
  dispatch(deleteChat(authToken,ptoken));
  setShow(false);
  redirectHome();
 }

  
  return (
    <div className={`hidden h-[88%] lg:fixed lg:inset-y-[13%] lg:z-10 lg:flex lg:flex-col transition-all duration-300 ${collapsed ? 'lg:w-16' : 'lg:w-72'}`}>
      {/* Collapse/Expand Button */}
      <button
        className=" z-30 shadow hover:bg-gray-100 transition  ml-auto mr-5 mb-2"
        onClick={() => setCollapsed((prev) => !prev)}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        style={{ outline: 'none' }}
      >
        {collapsed ? <GoSidebarCollapse size={20} /> : <GoSidebarExpand size={20} />}
      </button>
      {/* Sidebar component, swap this element with another sidebar if you like */}
      <div className={`flex grow flex-col gap-y-3 overflow-y-auto bg-white px-2 pb-4 justify-between transition-all duration-300 ${collapsed ? 'px-1' : 'px-2'}`} >
        <div className={`flex flex-col gap-y-2 ${collapsed ? 'items-center' : ''}`}>
          <div
            onClick={redirectHome}
            className={`text-sm flex items-center gap-4 font-semibold pt-1 cursor-pointer ${window.location.pathname === '/internal_ama' ? 'text-[var(--brand-primary)]' : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)]'} ${collapsed ? 'justify-center' : ''}`}
          >
            <HomeIcon className='size-6' />
            {!collapsed && 'Home'}
          </div>
          {/* <div className='text-sm flex items-center gap-3 font-semibold pt-1 text-gray-300 pb-4 border-b border-gray-200 cursor-not-allowed'><TextLeft className='text-xl'/>Content Repository</div> */}
          <div className='flex'>
          {/* <div className='text-sm flex items-center gap-4 font-semibold pt-1 text-[var(--brand-secondary)] cursor-default'><ClockHistory className='text-xl'/>Query Library</div> */}
          {/* {chat_history?.length > 0 && <div className='mt-2 ml-auto mr-4 cursor-pointer text-xs' onClick={handleClear}>Clear</div>} */}
          </div>

          <div className={`max-h-[50vh] overflow-y-auto hide-scrollbar listing mb-4 ${collapsed ? 'hidden' : ''}`}>
            {chat_history?.length > 0 && chat_history?.map((history, h_index) => {
              return (
                <div
                  onClick={() => {navigate(`/internal_ama/${history.prospect_token}`) }}
                  className="flex justify-between group my-auto cursor-pointer hover:text-[var(--brand-primary)] hover:bg-gray-200/50 rounded-md px-2 py-2"
                >
                  <p
                    title={history?.question}
                    className={`truncate my-auto capitalize pr-6 font-medium cursor-pointer ${id === history.prospect_token ? "text-[var(--brand-primary)]" : "text-[var(--brand-secondary)]"}`}
                  >
                    {history?.question?.length > 25 ? `${history?.question?.slice(0, 25)}...` : history?.question}
                  </p>
                  <div className="relative my-auto" ref={el => menuRefs.current[h_index] = el}>
                    <Trash onClick={() => { handleDelete(history.prospect_token); setMenuOpen(null); }}/>
                  </div>
                </div>
              );
            })}
          </div>
          {userType != "4" && <div
            onClick={()=>{navigate(`/Chat-Ai`);}}
            className={`text-sm flex items-center hover:text-[var(--brand-primary)] gap-4 font-semibold pt-1 text-[var(--brand-secondary)] cursor-pointer ${collapsed ? 'justify-center' : ''}`}
          >
            <DiNetbeans className='size-6' />
            {!collapsed && 'Train AI'}
          </div>}

          {userType != "4" && <div
            onClick={()=>{navigate(`/Analytics`);}}
            className={`text-sm flex items-center hover:text-[var(--brand-primary)] gap-4 font-semibold pt-1 text-[var(--brand-secondary)] cursor-pointer ${collapsed ? 'justify-center' : ''}`}
          >
            <BarChart className='size-6' />
            {!collapsed && 'Analytics'}
          </div>}

          {/* {chat_history?.length > 6 && <div className='w-full flex justify-end pr-8 text-[var(--brand-primary)]'>
            <p className='cursor-pointer' onClick={()=>{setMore(!more)}}>{`${more === true ? "More":"Less"}`}</p>      
          </div>} */}
        </div>

        {/* <div className='border-solid border-[1px] border-gray-400 rounded-xl mr-6'>
        <div className='text-sm flex items-center gap-4 font-semibold pt-1 text-[#808080] ml-4 mb-2 mt-1'>Chat Commands</div>
        <div className='border-solid mb-2 mx-2 border-[1.5px] border-[var(--brand-primary)] rounded-xl flex px-3 py-1 justify-between '>
          <div className='my-auto text-[var(--brand-primary)] font-bold text-lg mr-4'>/d</div>
          <div className='text-xs'>Search and retrieve relevant document from library.</div>
        </div>
        <div className='border-solid mb-2 mx-2 border-[1.5px] border-[var(--brand-primary)] rounded-xl flex px-3 py-1 justify-between '>
          <div className='my-auto text-[var(--brand-primary)] font-bold text-lg mr-4'>/t</div>
          <div className='text-xs'>Create a task in your to-do list. Mention date and time.</div>
        </div>
        <div className='border-solid mb-2 mx-2 border-[1.5px] border-[var(--brand-primary)] rounded-xl flex px-3 py-1 justify-between '>
          <div className='my-auto text-[var(--brand-primary)] font-bold text-lg mr-4'>/w</div>
          <div className='text-xs'>Search the web for this prompt.</div>
        </div>
        </div> */}


          {/* <nav className="flex flex-1 flex-col ">
            <ul role="list" className="flex flex-1 flex-col">
              <div className='mt-auto'>
                <li className="cursor-pointer">
                  <span href="/Setting"
                    className={`${subPageName == "settings" ? "bg-gray-50 text-[var(--brand-primary)]" : "text-[var(--brand-secondary)]"} group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6  hover:bg-gray-50 hover:text-[var(--brand-primary)]`}
                    // onClick={(e)=>{RedirectionControl(e, "setting")}}
                  >
                    <Cog6ToothIcon
                      className={`h-6 w-6 shrink-0 ${subPageName == "settings" ? "bg-gray-50 text-[var(--brand-primary)]":"text-gray-400"} group-hover:text-[var(--brand-primary)]`}
                      aria-hidden="true"
                    />
                    Settings
                  </span>
                </li>
              </div>

            </ul>
          </nav> */}
      </div>
      <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-10"
      //  initialFocus={cancelButtonRef} 
      onClose={handleClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                        Delete 
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                           Are you sure you want to delete?
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                    onClick={deleteEvent}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={handleClose}
                    // ref={cancelButtonRef}
                  >
                    No
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    </div>
  )
}

export default Sidebar